/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }

  createColumn(boardId, column) {
    return axios.post(`${this.url}/${boardId}/columns`, { column });
  }

  updateColumn(boardId, columnId, column) {
    return axios.patch(`${this.url}/${boardId}/columns/${columnId}`, {
      column,
    });
  }

  deleteColumn(boardId, columnId) {
    return axios.delete(`${this.url}/${boardId}/columns/${columnId}`);
  }

  reorderColumns(boardId, positionsHash) {
    return axios.post(`${this.url}/${boardId}/columns/reorder`, {
      positions_hash: positionsHash,
    });
  }

  createTask(boardId, task) {
    return axios.post(`${this.url}/${boardId}/tasks`, { task });
  }

  updateTask(boardId, taskId, task) {
    return axios.patch(`${this.url}/${boardId}/tasks/${taskId}`, { task });
  }

  deleteTask(boardId, taskId) {
    return axios.delete(`${this.url}/${boardId}/tasks/${taskId}`);
  }

  moveTask(boardId, taskId, { columnId, position }) {
    return axios.post(`${this.url}/${boardId}/tasks/${taskId}/move`, {
      kanban_column_id: columnId,
      position,
    });
  }
}

export default new KanbanAPI();
